module.exports = __webpack_public_path__ + "fonts/Austin-Roman.4149e66c.otf";